import React from 'react'

export default () => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="12.000000pt" height="12.000000pt" viewBox="0 0 72.000000 72.000000"
    preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,72.000000) scale(0.100000,-0.100000)"
      fill="#cccccc" stroke="none">
      <path d="M84 690 c5 -28 4 -30 -14 -20 -10 5 -30 10 -44 10 -22 0 -26 -5 -26
-29 0 -15 9 -40 20 -54 11 -14 20 -35 20 -46 0 -12 9 -39 20 -61 15 -29 18
-50 14 -84 -6 -39 -3 -48 19 -70 28 -28 47 -32 78 -16 17 10 18 8 9 -15 -15
-39 -12 -111 6 -153 27 -66 125 -152 173 -152 34 0 117 63 156 118 27 39 30
52 30 115 0 83 -15 112 -80 148 -55 31 -156 32 -207 2 l-36 -21 -6 49 c-5 38
-2 56 14 86 11 21 20 48 20 60 0 13 9 32 20 43 11 11 20 33 20 50 0 26 -4 30
-28 30 -15 0 -38 -7 -50 -16 -21 -15 -22 -14 -12 11 6 15 10 31 10 36 0 15
-37 10 -44 -6 -3 -8 -15 -15 -26 -15 -11 0 -20 7 -20 15 0 9 -9 15 -21 15 -19
0 -21 -4 -15 -30z m76 -50 c0 -6 10 -24 21 -39 14 -19 18 -34 13 -43 -10 -14
-14 -48 -17 -120 -1 -27 -5 -48 -10 -48 -4 0 -12 -10 -17 -22 l-9 -23 -7 23
c-3 12 -10 22 -15 22 -4 0 -5 15 -2 34 3 21 -1 46 -10 64 -10 21 -12 33 -4 41
7 7 6 16 -6 29 -16 18 -16 20 3 37 11 10 22 26 25 36 7 20 35 27 35 9z m277
-291 c24 -12 50 -34 58 -50 30 -57 12 -140 -41 -190 l-24 -22 25 73 c31 92 32
124 1 155 -45 45 -147 45 -192 0 -31 -31 -30 -63 1 -155 l25 -73 -24 22 c-53
50 -71 133 -41 190 17 34 87 71 134 71 19 0 54 -9 78 -21z"/>
      <path d="M560 693 c0 -25 -1 -26 -20 -8 -11 10 -36 18 -57 19 -45 1 -52 -15
-27 -71 10 -21 16 -54 15 -74 -2 -24 7 -55 24 -89 18 -36 24 -60 20 -79 -9
-42 26 -81 73 -81 20 0 42 4 48 8 19 12 35 52 29 71 -3 10 6 43 20 74 17 36
25 72 25 104 0 26 2 69 6 96 6 45 5 47 -19 47 -13 0 -36 -9 -51 -21 l-26 -20
0 25 c0 22 -4 26 -30 26 -26 0 -30 -4 -30 -27z"/>
    </g>
  </svg>
)
